import { Pagination } from 'antd';
import { PaginationProps } from 'antd/lib';
import Loading from 'components/common/Loading';
import useMember from 'hooks/useMember';
import debounce from 'lodash.debounce';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import NESTEDROUTE from 'utils/router';

const StaffLeaveProfileTable = () => {
  const { getStaffLeaveList } = useMember();
  const [loading, setLoading] = useState(false);

  const [staffLeaveList, setStaffLeaveList] = useState();
  const [state, setState] = useState({
    name: null,
    description: null,
    page: '1',
    page_size: '10',
    count: null,
    currentPage: 1,
  });
  const { name, description, count, currentPage, page, page_size } = state;
  const navigate = useNavigate();
  const nameRef = useRef();
  const codeRef = useRef();

  const onChangeInputName = (event) => {
    updateName(event.currentTarget.value);
  };
  const onChangeInputCode = (event) => {
    updateCode(event.currentTarget.value);
  };
  const updateName = useCallback(
    debounce((event) => {
      setState((pre) => ({
        ...pre,
        name: event,
        page: '1',
      }));
    }, 500),
    [],
  );
  const updateCode = useCallback(
    debounce((event) => {
      setState((pre) => ({
        ...pre,
        description: event,
        page: '1',
      }));
    }, 500),
    [],
  );
  useEffect(() => {
    // setLoading(true);

    getStaffLeaveList({
      ...(description && { description: description }),
      ...(name && { name: name }),
      ...(page && { page: page }),
      ...(page_size && { page_size: page_size }),
    }).then((res) => {
      setStaffLeaveList(res.data?.results);
      // setLoading(false);

      setState((pre) => ({
        ...pre,
        count: res?.data?.count,
        currentPage: res?.data?.page,
      }));
    });
  }, [name, description, page]);
  const itemRender: PaginationProps['itemRender'] = (
    _,
    type,
    originalElement,
  ) => {
    if (type === 'prev') {
      return <a className="mr-3">Previous</a>;
    }
    if (type === 'next') {
      return <a className="mr-3">Next</a>;
    }

    return originalElement;
  };
  const onChange = (pageNumber) => {
    setState((pre) => ({
      ...pre,
      page: pageNumber,
    }));
  };

  if (loading) return <Loading />;
  return (
    <div>
      <div
        style={{
          padding: '15px 25px 15px 32px',
          borderBottom: '0.5px solid #73A1E7',
        }}
      >
        <span style={{ fontWeight: 600, fontSize: 16, color: '#000000' }}>
          List of staff leave and absence profiles
        </span>
      </div>
      <div
        style={{
          display: 'flex',
          gap: 20,
          width: '100%',
          borderBottom: '0.5px solid #73A1E7',
          height: 70,
          paddingBottom: 10,
        }}
      >
        <div style={{ width: '10%' }}></div>

        <div
          style={{
            width: '40%',
            display: 'flex',
            flexDirection: 'column',
            paddingTop: '4px',
            fontWeight: 600,
            fontSize: 14,
            color: '#000000',
          }}
        >
          <div>
            Name
            <img
              src="/assets/drop-down-upward.svg"
              alt="arrow"
              style={{ marginLeft: '10px' }}
            />
          </div>
          <input
            ref={nameRef}
            onChange={(e) => onChangeInputName(e)}
            style={{ marginTop: '2px', width: '95%' }}
            className="common_custom_input_search"
          />
        </div>
        <div
          style={{
            width: '50%',
            display: 'flex',
            flexDirection: 'column',
            paddingTop: '4px',
            fontWeight: 600,
            fontSize: 14,
            color: '#000000',
          }}
        >
          <div>
            Description
            <img
              src="/assets/drop-down-upward.svg"
              alt="arrow"
              style={{ marginLeft: '10px' }}
            />
          </div>
          <input
            ref={codeRef}
            onChange={(e) => onChangeInputCode(e)}
            style={{ marginTop: '2px', width: '90%' }}
            className="common_custom_input_search"
          />
        </div>
      </div>
      {(staffLeaveList as any)?.length > 0 ? (
        (staffLeaveList as any)?.map((item, index: number) => (
          <div
            className="hoverCell"
            onClick={() =>
              navigate(NESTEDROUTE.staff_leave_profile_detail, {
                state: { id: item?.id, name: item?.name },
              })
            }
            style={{
              display: 'flex',
              gap: 20,
              width: '100%',
              borderBottom: '0.5px solid #73A1E7',
              height: 70,
            }}
          >
            <div style={{ width: '10%' }}></div>
            <div
              style={{
                width: '40%',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
              className="common_table_text"
            >
              {item.name}
            </div>
            <div
              style={{
                width: '50%',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
              className="common_table_text"
            >
              {item.description}
            </div>
          </div>
        ))
      ) : (
        <p style={{ textAlign: 'center', color: '#E4E4E4', marginTop: 20 }}>
          No item
        </p>
      )}
      {(staffLeaveList as any)?.length > 0 && (
        <div className="is-flex is-justify-content-center is-align-content-center mt-2 staff_leave_footer">
          <Pagination
            showSizeChanger={false}
            itemRender={itemRender}
            defaultPageSize={10}
            onChange={onChange}
            defaultCurrent={1}
            total={count}
            current={currentPage}
          />
        </div>
      )}
    </div>
  );
};

export default StaffLeaveProfileTable;
